// extracted by mini-css-extract-plugin
export default {"box":"DonutNew_box__PzY1F"};